export default __webpack_public_path__ + "static/media/AI.f5218dff.svg";